<template>
  <el-tooltip class="tip" placement="top" popper-class="tip">
    <!-- eslint-disable vue/no-v-html -->
    <div slot="content" placement="top-start" v-html="tipContent" />
    <!-- eslint-enable vue/no-v-html -->
    <img src="../../assets/icons/i_tip.svg" alt="" />
  </el-tooltip>
</template>

<script>
export default {
  name: "Tip",
  props: {
    label: {
      type: String,
      default: null,
    },
    tipContent: {
      type: String,
      default:
        "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
    },
  },
};
</script>

<style lang="scss"></style>
